import React from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { API } from "../../lib/api";
import { trackAppTap } from "../../lib/appStats";

// Android: downloads the app file. iPhone: Add to Home Screen steps. Computer: download page.
export const AppDownloadLink = ({ source, device, testid, className, children }) => {
  if (device === "android") return (
    <a href={`${API}/mobile-app/android.apk`} download="Ishukart.apk" data-testid={testid} className={className}
      onClick={() => { trackAppTap(source); toast.success("Downloading Ishukart", { description: "Open the file when it finishes and tap Install." }); }}>
      {children}
    </a>
  );
  return (
    <Link to={device === "ios" ? "/get-app#iphone" : "/get-app"} onClick={() => trackAppTap(source)} data-testid={testid} className={className}>
      {children}
    </Link>
  );
};

export default AppDownloadLink;
